import { MoneyBox } from '@apply/components';
import { formatCurrencyOrUndefined } from '@apply/ui';
import { IBudgetFixFlip } from '@apply/api/src/api/ApplyApi';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';
import { useBudgetFixFlipField } from '../../../../../queries/useBudgetFixFlipField';

interface AcquisitionPriceProps {
    required?: boolean;
    propertyGuid: string;
    isReview?: boolean;
}

export const AcquisitionPrice: React.FC<AcquisitionPriceProps> = ({ required = false, propertyGuid, isReview = false }) => {
    const [acquisitionPrice, set_acquisitionPrice] = useBudgetFixFlipField<number>(
        propertyGuid,
        (b) => (b.values?.['Property Cost']?.['Acquisition Price'] as number) ?? 0,
        (b, v) => ({ ...b, values: { ...b.values, 'Property Cost': { ...b.values?.['Property Cost'], 'Acquisition Price': v } } })
    );
    const label = 'Acquisition Price (Must tie to purchase contract)';
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={formatCurrencyOrUndefined(acquisitionPrice)}
                />
            ) : (
                <MoneyBox
                    id={'acquisitionPrice'}
                    allowNegative={false}
                    value={acquisitionPrice}
                    onChange={(value) => set_acquisitionPrice(value)}
                    required={required}
                    label={label}
                />
            )}
        </>
    );
};
